import { OfferBase } from './bases/offer-base';
import { toApi as toApiBase } from './bases/offer-base';

export class CouponUnique extends OfferBase {
  coupon_diffusion_type = 'QR';
  coupon_file: string;
  coupon_filename = '';
  coupon_rate: number;
  coupon_total_number: number;
  coupon_unique_codes: any;
  coupon_value: number;
  max_coupon_per_user = 1;
  segments: any = [];
  total_consumers: number;

  constructor(payload: Object = {}) {
    super();

    Object.assign(this, payload);

    this.trimTimezoneFromDates();
  }
}

export function toApi(data) {
  data = toApiBase(data);

  return data;
}
